import { isObject } from '../../../helpers';

const getValueFromArray = (key, arr, prefix, suffix) => {
  const valuesFromArray = arr
    .map(obj => {
      const value = isObject(obj) ? obj[key] : obj;
      if (typeof value !== 'boolean' && !value) return null;
      const objValueWithPrefixSuffix = `${prefix}${value}${suffix}`;
      const objValueLink = obj.url || '';

      return { keyField: key, [key]: objValueWithPrefixSuffix, url: objValueLink };
    })
    .filter(Boolean);
  return valuesFromArray.length ? valuesFromArray : null;
};

export default getValueFromArray;
